<template>
  <div class="container-fluid" v-if="$route.meta.requiresAuth">
    <div class="row">
      <AppSlideTab />
      <main class="col-md-9 ms-sm-auto col-lg-10 layout-content-outer">
        <Header />
        <div class="layout-content-inner mt-3">
          <router-view />
        </div>
      </main>
    </div>
  </div>
  <div class="container-fluid" v-if="!$route.meta.requiresAuth">
    <router-view />
  </div>
  <!-- <ReLoginModal v-if="showReloginPopup" /> -->
</template>
<script>
import AppSlideTab from "./components/SlideTabs.vue";
import Header from "./components/Header.vue";
// import ReLoginModal from "./components/ReLogin.vue";
import useValidate from "@vuelidate/core";
import { reactive, onMounted } from "vue";
export default {
  components: {
    AppSlideTab: AppSlideTab,
    Header: Header,
  },
  setup () {
    const state = reactive( {
      v$: useValidate(),
      showReloginPopup: false,
      lockstatus: '',
      lockstatusreason: '',
    } )

    onMounted( () => {

    } )
    return { state }
  }
}
</script>
<style scoped></style>